@let buildingValue = building();
@let portfolioIdValue = portfolioId();
@if (buildingValue) {
  <cfp-building-header
    [address]="displayAddress() ?? []"
    [name]="buildingValue.name"
    [showMonumentIcon]="isMonument()"
    [countryCode]="countryCode()"
    [buildingCode]="buildingValue.code"
    [buildingId]="buildingValue.id"
    [portfolioId]="portfolioId()"
    [hideSelect]="hideSelect()"
    [hideDropdown]="hideDropdown()"
    [hideGoToAllBuildings]="hideGoToAllBuildings()"
    [hideDeleteBuilding]="hideDeleteBuilding()"
    [hideManageBuildingTags]="hideManageBuildingTags()"
    [canDownloadReport]="canDownloadReport()"
    [buildingHeaderClass]="buildingHeaderClass()"
    [customBuildingImageUrl]="customBuildingImageUrl()"
  >
    <ng-content select="[building-header-dropdown-options-top]" dropdown-options-top />
    <ng-container building-header>
      @if (!onlyAllowNgContent()) {
        @let pdfUrlValue = url();
        @let fileNameValue = fileName();
        @let labelGroupValue = labelGroup();
        @if (customBuildingHeaderComponent) {
          <ng-container
            *ngComponentOutlet="
              customBuildingHeaderComponent;
              inputs: {
                building: buildingValue,
                pdfUrl: pdfUrlValue,
                fileName: fileNameValue,
                labelGroup: labelGroupValue
              }
            "
          />
        } @else {
          @let showDownloadReportButtonValue = showDownloadReportButton();
          @if (showDownloadReportButtonValue || (!showNotesAsCard && hasBuildingNotesLicense())) {
            <div class="btn-group toggle-btn-group">
              @if (showDownloadReportButtonValue && pdfUrlValue && fileNameValue && labelGroupValue) {
                <cfp-building-pdf-download-button
                  [url]="pdfUrlValue"
                  [fileName]="fileNameValue"
                  [labelGroup]="labelGroupValue"
                />
              }
              @defer (when !showNotesAsCard && hasBuildingNotesLicense()) {
                <cfp-notes-button [portfolioId]="portfolioIdValue" [buildingId]="buildingValue.id" />
              }
            </div>
          }
          @if (hasBuildingDocumentsLicense() || (showNotesAsCard && hasBuildingNotesLicense())) {
            <div class="row g-4 building-header-cards">
              @defer (when hasBuildingDocumentsLicense()) {
                <cfp-documents-card
                  [buildingId]="buildingValue.id"
                  class="col-12 d-print-none"
                  [class.col-md-6]="showNotesAsCard"
                />
              }
              @defer (when showNotesAsCard && hasBuildingNotesLicense()) {
                <cfp-notes-card
                  [portfolioId]="portfolioIdValue"
                  [buildingId]="buildingValue.id"
                  class="col-12 d-print-none"
                  [class.col-md-6]="hasBuildingDocumentsLicense()"
                />
              }
            </div>
          }
        }
      }
      <ng-content />
    </ng-container>
    <ng-container building-header-bottom>
      @if (hasEnergyLabelRequirementLicense()) {
        @defer {
          <cfp-energy-label-requirement-status
            [buildingId]="buildingValue.id"
            [energyLabelRequirement]="energyLabelRequirement()"
            [showReason]="true"
            [classes]="'mt-3'"
          />
        }
      }
      <ng-content select="[building-header-bottom]" />
    </ng-container>
  </cfp-building-header>
}
